import {
  RENTER_LEASE_SITUATION_OPTION_FIRM,
  RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH,
  RENTER_LEASE_SITUATION_OPTION_NO_LEASE,
} from 'common/leaseSituationOptionItems';

// Front channels.
export const FRONT_CHANNEL_CUSTOMER_TEXTS = process.env.FRONT_CHANNEL_CUSTOMER_TEXTS || '';
export const FRONT_INBOX_CUSTOMER_TEXTS = process.env.FRONT_INBOX_CUSTOMER_TEXTS || '';
export const FRONT_CHANNEL_REENGAGEMENT = process.env.FRONT_CHANNEL_REENGAGEMENT || '';
export const FRONT_CHANNEL_ADMIN_EMAIL = process.env.FRONT_CHANNEL_ADMIN_EMAIL || '';
export const FRONT_CHANNEL_TOUR_GUIDE_SUPPORT = process.env.FRONT_CHANNEL_TOUR_GUIDE_SUPPORT || '';
export const FRONT_CHANNEL_LEASING_OPERATIONS_TEXTS = process.env.FRONT_CHANNEL_LEASING_OPERATIONS_TEXTS || ''; // eslint-disable-line max-len
export const FRONT_CHANNEL_LISTING_INQUIRIES_TEXTS = process.env.FRONT_CHANNEL_LISTING_INQUIRIES_TEXTS || ''; // eslint-disable-line max-len
export const FRONT_NUMBER_LISTING_INQUIRIES = process.env.FRONT_NUMBER_LISTING_INQUIRIES || '';
export const FRONT_CHANNEL_AGENT_LANDLORD_TEXTS = process.env.FRONT_CHANNEL_AGENT_LANDLORD_TEXTS || '';

// Front inbox types.
export const FRONT_INBOX_TYPE_CUSTOMER_SUPPORT = 'customerSupport';
export const FRONT_INBOX_TYPE_APARTMENT_LOCATOR = 'apartmentLocator';
export const FRONT_INBOX_TYPE_LISTING_INQUIRIES = 'listingInquiries';
export const FRONT_INBOX_TYPE_LEASING_OPERATIONS = 'leasingOperations';
export const FRONT_INBOX_TYPE_AGENT_LANDLORD = 'agentLandlord';

export const FRONT_INBOX_ID_CUSTOMER_SUPPORT = 'inb_ahzv';
export const FRONT_INBOX_ID_APARTMENT_LOCATOR = 'inb_jigz';
export const FRONT_INBOX_ID_LISTING_INQUIRIES = 'inb_1yor1';
export const FRONT_INBOX_ID_LEASING_OPERATIONS = 'inb_gsjv';
export const FRONT_INBOX_ID_AGENT_LANDLORD = 'inb_64j5';

export const FRONT_INBOX_TYPE_TO_ID_MAPPING = {
  [FRONT_INBOX_TYPE_CUSTOMER_SUPPORT]: FRONT_INBOX_ID_CUSTOMER_SUPPORT,
  [FRONT_INBOX_TYPE_APARTMENT_LOCATOR]: FRONT_INBOX_ID_APARTMENT_LOCATOR,
  [FRONT_INBOX_TYPE_LISTING_INQUIRIES]: FRONT_INBOX_ID_LISTING_INQUIRIES,
  [FRONT_INBOX_TYPE_LEASING_OPERATIONS]: FRONT_INBOX_ID_LEASING_OPERATIONS,
  [FRONT_INBOX_TYPE_AGENT_LANDLORD]: FRONT_INBOX_ID_AGENT_LANDLORD,
};

export const FRONT_INBOX_TYPES = [
  FRONT_INBOX_TYPE_CUSTOMER_SUPPORT,
  FRONT_INBOX_TYPE_APARTMENT_LOCATOR,
  FRONT_INBOX_TYPE_LISTING_INQUIRIES,
  FRONT_INBOX_TYPE_LEASING_OPERATIONS,
  FRONT_INBOX_TYPE_AGENT_LANDLORD,
];

// Front conversation statuses.
export const FRONT_CONVERSATION_STATUS_ASSIGNED = 'assigned';
export const FRONT_CONVERSATION_STATUS_UNASSIGNED = 'unassigned';
export const FRONT_CONVERSATION_STATUS_ARCHIVED = 'archived';
export const FRONT_CONVERSATION_STATUS_DELETED = 'deleted';
export const FRONT_CONVERSATION_STATUS_OPEN = 'open';
export const FRONT_CONVERSATION_STATUS_INVISIBLE = 'invisible';

export const FRONT_CONVERSATION_STATUS_LIST = [
  FRONT_CONVERSATION_STATUS_ASSIGNED,
  FRONT_CONVERSATION_STATUS_UNASSIGNED,
  FRONT_CONVERSATION_STATUS_ARCHIVED,
  FRONT_CONVERSATION_STATUS_DELETED,
  FRONT_CONVERSATION_STATUS_OPEN,
];

// Front app author ID.
export const FRONT_APP_AUTHOR_ID = 'tea_6kfn';

// Front tags to capture.
export const FRONT_TAG_LEASE_SITUATION_OPTION_FIRM = 'firm lease';
export const FRONT_TAG_LEASE_SITUATION_OPTION_NO_LEASE = 'no lease';
export const FRONT_TAG_LEASE_SITUATION_OPTION_MONTH_TO_MONTH = 'mtm lease';

export const FRONT_TAG_COMPLETED_TOUR = 'post tour';
export const FRONT_TAG_STILL_TOURING = 'still touring';
export const FRONT_TAG_ROOMMATES = 'roommates';
export const FRONT_TAG_MULTIPLE_APPLICATIONS = 'multiple apps';
export const FRONT_TAG_CHANGED_MOVE_IN_DATE = 'changed move-in';
export const FRONT_TAG_HAS_PETS = 'pets';
export const FRONT_TAG_LIMITED_TOURS = 'limited tours';

export const FRONT_TAG_WANTS_TO_APPLY = 'wants to apply';
export const FRONT_TAG_STARTED_APPLICATION = 'started app';
export const FRONT_TAG_COMPLETED_APPLICATION = 'completed app';
export const FRONT_TAG_PAID_APPLICATION_FEE = 'paid app fee';
export const FRONT_TAG_PENDING_DOCUMENTS = 'pending documents';
export const FRONT_TAG_REVIEWING_DOCUMENTS = 'reviewing documents';
export const FRONT_TAG_PENDING_VERIFICATION = 'pending go4rent';
export const FRONT_TAG_PENDING_TRANSUNION = 'pending transunion';
export const FRONT_TAG_APPLICATION_DELIVERED = 'app delivered';
export const FRONT_TAG_PENDING_LANDLORD = 'pending landlord';
export const FRONT_TAG_APPLICATION_ACCEPTED = 'app accepted';
export const FRONT_TAG_DEPOSIT_PAID = 'deposit paid';
export const FRONT_TAG_LEASE_DRAFT_PENDING = 'lease draft pending';
export const FRONT_TAG_LEASE_SENT = 'lease sent';
export const FRONT_TAG_LEASE_SIGNED = 'lease signed!';

export const FRONT_TAG_PREQUAL_IS_QUALIFIED = 'YES Qualified ✅';
export const FRONT_TAG_PREQUAL_NOT_QUALIFIED = 'NOT Qualified 🚫';

export const FRONT_APPLICATION_TAGS = [
  FRONT_TAG_WANTS_TO_APPLY,
  FRONT_TAG_STARTED_APPLICATION,
  FRONT_TAG_COMPLETED_APPLICATION,
  FRONT_TAG_PAID_APPLICATION_FEE,
  FRONT_TAG_PENDING_DOCUMENTS,
  FRONT_TAG_REVIEWING_DOCUMENTS,
  FRONT_TAG_PENDING_VERIFICATION,
  FRONT_TAG_PENDING_TRANSUNION,
  FRONT_TAG_APPLICATION_DELIVERED,
  FRONT_TAG_PENDING_LANDLORD,
  FRONT_TAG_APPLICATION_ACCEPTED,
  FRONT_TAG_DEPOSIT_PAID,
  FRONT_TAG_LEASE_DRAFT_PENDING,
  FRONT_TAG_LEASE_SENT,
  FRONT_TAG_LEASE_SIGNED,
];

export const FRONT_TAG_APPLICATION_REJECTED = 'app rejected';
export const FRONT_TAG_MOVED_IN = 'moved in';
export const FRONT_TAG_BLAST_FOUND_A_PLACE = 'blast found a place';
export const FRONT_TAG_BLAST_RESPONDED_BACK = 'blast responded back';
export const FRONT_TAG_SUNROOM_CLUB_MEMBERSHIP_PAID = 'sunroom club paid';
export const FRONT_TAG_SUNROOM_CLUB_QUESTIONNAIRE_SUBMITTED = 'sunroom club form submitted';
// "Do not message me" kind of tags.
export const FRONT_TAG_BLAST_INVALID_NUMBER = 'blast invalid number';
export const FRONT_TAG_BAD_NUMBER = 'bad number';
export const FRONT_TAG_BLAST_STOP = 'blast stop';
export const FRONT_TAG_DEAD_LEAD = 'dead lead';
export const FRONT_TAG_DO_NOT_TEXT = 'do not text';
export const FRONT_TAG_STOP_TEXTING = 'stop texting';

export const FRONT_ALL_TAGS = [
  FRONT_TAG_COMPLETED_TOUR,
  FRONT_TAG_STILL_TOURING,
  FRONT_TAG_ROOMMATES,
  FRONT_TAG_MULTIPLE_APPLICATIONS,
  FRONT_TAG_APPLICATION_REJECTED,
  FRONT_TAG_APPLICATION_ACCEPTED,
  FRONT_TAG_CHANGED_MOVE_IN_DATE,
  FRONT_TAG_HAS_PETS,
  FRONT_TAG_WANTS_TO_APPLY,
  FRONT_TAG_STARTED_APPLICATION,
  FRONT_TAG_COMPLETED_APPLICATION,
  FRONT_TAG_PAID_APPLICATION_FEE,
  FRONT_TAG_PENDING_DOCUMENTS,
  FRONT_TAG_REVIEWING_DOCUMENTS,
  FRONT_TAG_PENDING_VERIFICATION,
  FRONT_TAG_PENDING_TRANSUNION,
  FRONT_TAG_APPLICATION_DELIVERED,
  FRONT_TAG_PENDING_LANDLORD,
  FRONT_TAG_DEPOSIT_PAID,
  FRONT_TAG_LEASE_DRAFT_PENDING,
  FRONT_TAG_LEASE_SENT,
  FRONT_TAG_LEASE_SIGNED,
  FRONT_TAG_MOVED_IN,
  FRONT_TAG_BLAST_FOUND_A_PLACE,
  FRONT_TAG_BLAST_RESPONDED_BACK,
  FRONT_TAG_BLAST_INVALID_NUMBER,
  FRONT_TAG_BAD_NUMBER,
  FRONT_TAG_BLAST_STOP,
  FRONT_TAG_DEAD_LEAD,
  FRONT_TAG_DO_NOT_TEXT,
  FRONT_TAG_STOP_TEXTING,
];

export const FRONT_DO_NOT_TEXT_TAGS = [
  FRONT_TAG_BLAST_INVALID_NUMBER,
  FRONT_TAG_BAD_NUMBER,
  FRONT_TAG_BLAST_STOP,
  FRONT_TAG_DEAD_LEAD,
  FRONT_TAG_DO_NOT_TEXT,
  FRONT_TAG_STOP_TEXTING,
];

export const leaseSituationTagMap = {
  [RENTER_LEASE_SITUATION_OPTION_FIRM]: FRONT_TAG_LEASE_SITUATION_OPTION_FIRM,
  [RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH]: FRONT_TAG_LEASE_SITUATION_OPTION_MONTH_TO_MONTH,
  [RENTER_LEASE_SITUATION_OPTION_NO_LEASE]: FRONT_TAG_LEASE_SITUATION_OPTION_NO_LEASE,
};

export const FRONT_REQUEST_LOG_STATUS_PENDING = 'pending';
export const FRONT_REQUEST_LOG_STATUS_STARTED = 'started';
export const FRONT_REQUEST_LOG_STATUS_DELAYED = 'delayed';
export const FRONT_REQUEST_LOG_STATUS_FAILED = 'failed';
export const FRONT_REQUEST_LOG_STATUS_SUCCESS = 'success';
